import * as prismic from '@prismicio/client'

export const repositoryName = 'nierkeuze';
const endpoint = prismic.getEndpoint(repositoryName);

export const client = prismic.createClient(endpoint, {
    accessToken: 'MC5ZakI1OUJFQUFDZ0FqMW1f.77-9ae-_ve-_vQ9u77-977-977-9LkpPCe-_ve-_vWAyG--_ve-_vVJT77-9GgIIV04wKBgo'
});